<template>
    <div class="side-menu">
        <el-row style="width: 100%;">
            <el-col :span="8" :offset="6">
                <div>
                    <img src="../../assets/logo.png" style="height: 5vh;margin-top: 1.5vh;">
                </div>
            </el-col>
            <el-col :span="10" 
                style="height: 8vh;display: flex;flex-direction: column;justify-content: center;">
                <el-menu :default-active="activeIndex" class="el-menu-demo" router menu-trigger="hover " unique-opened
                    mode="horizontal" background-color="transparent" text-color="white" active-text-color="white">
                    <el-menu-item class="item-lv1" index="1" :route="{ path: '/' }" style="width: 10%;">首页</el-menu-item>
                    <el-menu-item class="item-lv1" index="2" :route="{ path: '/knocking' }"
                        style="width: 17%;">爆震技术</el-menu-item>
                    <el-submenu index="3" class="item-lv1" style="width: 15%;margin-left: 2%;" @click.native.prevent="handleSubmenuClick('航空动力')">
                        <template slot="title">航空动力</template>
                        <el-menu-item index="3-1"
                            :route="{ path: '/engine', query: { id: 'WP40' } }">TH-WP40</el-menu-item>
                        <el-menu-item index="3-2"
                            :route="{ path: '/engine', query: { id: 'WP60' } }">TH-WP60</el-menu-item>
                        <el-menu-item index="3-3"
                            :route="{ path: '/engine', query: { id: 'WP100' } }">TH-WP100</el-menu-item>
                        <el-menu-item index="3-4"
                            :route="{ path: '/engine', query: { id: 'WP125' } }">TH-WP125</el-menu-item>
                        <el-menu-item index="3-5"
                            :route="{ path: '/engine', query: { id: 'WP160' } }">TH-WP160</el-menu-item>
                        <el-menu-item index="3-6"
                            :route="{ path: '/engine', query: { id: 'WZ150' } }">TH-WZ150</el-menu-item>
                        <el-menu-item index="3-7"
                            :route="{ path: '/engine', query: { id: 'WD200' } }">TH-WD200</el-menu-item>
                    </el-submenu>
                    <!-- <el-menu-item class="item-lv1" style="width: 15%;" @click="goToenEnergy">能源方案</el-menu-item> -->
                    <el-submenu index="4" class="item-lv1" style="width: 15%;;margin-left: 2.5%;" @click.native.prevent="handleSubmenuClick('绿色能源')">
                        <template slot="title">绿色能源</template>
                        <el-menu-item index="4-1"
                            :route="{ path: '/energy', query: { id: 'turbine' } }">先进燃气轮机</el-menu-item>
                        <el-menu-item index="4-2"
                            :route="{ path: '/energy', query: { id: 'burner' } }">新型燃烧器</el-menu-item>
                        <el-menu-item index="4-3"
                            :route="{ path: '/energy', query: { id: 'electrical' } }">电机一站式节能解决方案</el-menu-item>
                        <el-menu-item index="4-4"
                            :route="{ path: '/energy', query: { id: 'motor' } }">高速叶轮机械产品</el-menu-item>
                    </el-submenu>
                    <el-submenu index="5" class="item-lv1" style="width: 15%;;margin-left: 2.5%;" @click.native.prevent="handleSubmenuClick('关于我们')">
                        <template slot="title">关于我们</template>
                        <el-menu-item index="5-1"
                            :route="{ path: '/about', query: { id: 'introduce' } }">企业介绍</el-menu-item>
                        <el-menu-item index="5-2"
                            :route="{ path: '/about', query: { id: 'certification' } }">资质荣誉</el-menu-item>
                    </el-submenu>
                    <el-menu-item class="item-lv1" index="6" style="width: 15%;"
                        :route="{ path: '/joinus' }">加入我们</el-menu-item>

                </el-menu>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    name: 'HomeView',
    data() {
        return {
            activeIndex: '1'
        }
    },
    methods: {
        handleSubmenuClick(title, event){
            if(title==='航空动力'){
                this.$router.push('/engine?id=title');
            }
            else if(title==='关于我们'){
                this.$router.push('/about?id=title');
            }
            else if(title==='绿色能源'){
                this.$router.push('/energy?id=title');
            }
            
        },
        goToenEnergy(){
            window.open('http://www.Thu-e.com', '_blank','location=no'); 
        }
    }

}
</script>

<style lang="scss" scoped>
.side-menu {
    width: 100%;
    height: 8vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    font-family: QHKT;
    letter-spacing: 2px;
    background-color:rgba(79,79,79,0.6);
}

::v-deep .el-menu.el-menu--horizontal {
    border: none;
}

.el-menu .el-menu-item {
    font-family: QHKT;
}

.el-menu--horizontal>.el-menu-item:hover {
    background-color: transparent !important;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
    background-color: transparent !important;
    border: none;
}

::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: 0;
    text-decoration: none;
}

.el-menu--horizontal>.el-submenu {
    border: none;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
    font-size: 22px;
    font-weight: 1000;
    border-bottom: 0;
    text-decoration: none;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    font-size: 24px;
    transition: font-size 0.5s;
    background-color: transparent !important;
}

.el-menu-demo {
    background-color: transparent !important;
    border: none;

    .item-lv1 {
        font-size: 22px;
        font-weight: 1000;
        border: none;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .item-lv1:hover {
        font-size: 24px;
        transition: font-size 0.5s;
    }
}

.el-menu-demo .is-active {
    background-color: transparent !important;
}
</style>